import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	Router,
	RouterOutlet,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';

import { environment } from '../environments/environment';

import { AdminHeaderComponent } from 'projects/admin/src/app/components/admin-header/admin-header.component';
import AdminSideMenuComponent from 'projects/admin/src/app/components/admin-side-menu/admin-side-menu.component';
import { ADMIN_NAV_LINKS } from 'projects/admin/src/app/routing/admin-nav-links';
import { AppContainerComponent } from 'shared/components/app-container/app-container.component';
import { CookieConsentComponent } from 'shared/components/cookie-consent/cookie-consent.component';
import { MatSpinnerComponent } from 'shared/components/mat-spinner/mat-spinner.component';
import { VersionMismatchModalComponent } from 'shared/components/version-mismatch-modal/version-mismatch-modal.component';
import { AuthBaseService } from 'shared/services/auth-base.service';
import { convertTooltipMessageToInnerHtml } from 'shared/tools/tooltip';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [
		AppContainerComponent,
		CdkScrollable,
		CookieConsentComponent,
		MatSpinnerComponent,
		RouterOutlet,
		VersionMismatchModalComponent,
		AdminSideMenuComponent,
		AdminHeaderComponent,
	],
})
export class AppComponent implements OnInit {
	protected readonly keycloak = inject(Keycloak);
	protected readonly navLinks = ADMIN_NAV_LINKS;
	protected readonly isLoading = signal(false);
	protected readonly username = signal(this.keycloak.tokenParsed?.name ?? '');

	protected environment = environment.environment;

	readonly authService = inject(AuthBaseService);

	private readonly router = inject(Router);
	private readonly translateService = inject(TranslateService);
	private readonly destroyRef = inject(DestroyRef);

	constructor() {
		this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
			if (event instanceof NavigationStart) {
				this.isLoading.set(true);
			} else if (
				event instanceof NavigationEnd ||
				event instanceof NavigationCancel ||
				event instanceof NavigationError
			) {
				this.isLoading.set(false);
			}
		});
	}

	ngOnInit() {
		convertTooltipMessageToInnerHtml();
	}

	logout() {
		this.authService.logout();
	}

	translateLanguageTo(lang: string) {
		this.translateService.use(lang.toLocaleLowerCase());
		localStorage.setItem('currentLang', lang);
	}
}
